import { render, staticRenderFns } from "./PCTroskoviPoGrupama.vue?vue&type=template&id=a09547e4&"
import script from "./PCTroskoviPoGrupama.vue?vue&type=script&lang=ts&"
export * from "./PCTroskoviPoGrupama.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports